import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardTitle,
} from '@one-thd/sui-atomic-components';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import { extend, QueryProvider } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ATCConfirmationProductPod } from './ATCConfirmationProductPod';

export const ATCConfirmation = ({ itemId }) => {

  const { store } = useContext(ExperienceContext);
  const defaultVariables = {
    storeId: store.storeId
  };
  return (
    <div data-testid="assistant-atc-confirmation" className="sui-my-3">
      <QueryProvider
        cacheKey="atc-confirmation"
        defaultVariables={defaultVariables}
      >
        <Card
          variant="border"
          orientation="vertical"
          disablePadding
        >
          <div className="sui-border-solid sui-border-b-1 sui-rounded-base sui-border-primary sui-p-4">
            <CardTitle
              leadingIcon={<ConfirmedFilled color="success" />}
              header="Added to Cart"
              headerWeight="bold"
              headerVariant="h3"
              actionPosition="start"
              grow
            />
          </div>
          <ATCConfirmationProductPod itemId={itemId} />
        </Card>
      </QueryProvider>
    </div>
  );
};

ATCConfirmation.propTypes = {
  itemId: PropTypes.string.isRequired
};

ATCConfirmation.dataModel = extend(ATCConfirmationProductPod);
